import { trans } from "../../lib/utils";

function Loader() {
  return (
    <div className="d-inline-block small">
      <img
        src={window["appConfig"]()
          ["path"]()
          .concat("assets/images/loading.gif")}
      ></img>
      <span className="ms-2 text-success">
        {trans("Loading please wait...")}
      </span>
    </div>
  );
}

export default Loader;
